import { render, staticRenderFns } from "./EditStep4.vue?vue&type=template&id=5a9a4a6c"
import script from "./EditStep4.vue?vue&type=script&lang=js"
export * from "./EditStep4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports